import Vue from "vue";
import Vuex from "vuex";
import NbaModule from "@/store/modules/Nba.js";
import MlbModule from "@/store/modules/Mlb.js";
import NhlModule from "@/store/modules/Nhl.js";
import NflModule from "@/store/modules/Nfl.js";
import notification from "@/store/modules/notification.js";
import userModule from "@/store/modules/users.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    NbaModule,
    MlbModule,
    NhlModule,
    NflModule,
    notification,
    userModule,
  },
});
